import { Pipe, PipeTransform } from '@angular/core';
import { FormUtilService } from '../../services/form-util.service';
import { IAttachment } from '../attachments/models/attachments.model';

@Pipe({
  name: 'isIAttachment',
  pure: true,
  standalone: true,
})
export class IsIAttachmentPipe implements PipeTransform {
  transform(element: any): element is IAttachment {
    return FormUtilService.isIAttachment(element);
  }
}
